import { render, staticRenderFns } from "./tenseMore.vue?vue&type=template&id=0f1b1638&scoped=true&"
import script from "./tenseMore.vue?vue&type=script&lang=js&"
export * from "./tenseMore.vue?vue&type=script&lang=js&"
import style0 from "./tenseMore.vue?vue&type=style&index=0&id=0f1b1638&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1b1638",
  null
  
)

export default component.exports